import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { TextWidget } from '@plone/volto/components';

const messages = defineMessages({
  latitude: {
    id: 'latitude',
    defaultMessage: 'Latitudine',
  },
  longitude: {
    id: 'longitude',
    defaultMessage: 'Longitudine',
  },
});

const Sidebar = ({
  block,
  data,
  onChangeBlock,
  openObjectBrowser,
  required,
}) => {
  const intl = useIntl();

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage id="cordinate" defaultMessage="Cordinate" />
        </h2>
      </header>

      <Segment className="form">
        <TextWidget
          id="latitude"
          title={intl.formatMessage(messages.latitude)}
          value={data.latitude}
          onChange={(name, value) => {
            onChangeBlock(block, {
              ...data,
              latitude: value,
            });
          }}
        />
        <TextWidget
          id="longitude"
          title={intl.formatMessage(messages.longitude)}
          value={data.longitude}
          onChange={(name, value) => {
            onChangeBlock(block, {
              ...data,
              longitude: value,
            });
          }}
        />
      </Segment>
    </Segment.Group>
  );
};

Sidebar.propTypes = {
  block: PropTypes.string.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  openObjectBrowser: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default Sidebar;
